import styled from "styled-components";

export const CheckboxGroupField = styled.div`
  .ant-checkbox-wrapper {
    margin: 0;
    width: 100%;
  }
`;
